<template>
  <FreePageLayout>
    <template #header>
      <FreeHeader class="p-4" is-centered>
        <template #leftAction>
          <FreeBackButton
            @click="
              router.replace({
                name: 'MainPage',
                query: {
                  source: 'special_offers',
                  sourceElement: 'back_button',
                },
              })
            "
          />
        </template>
        <template #default>
          <h2
            class="text-text-neutral-primary text-center text-lg font-semibold"
          >
            {{ t('specialOffer.allTitle') }}
          </h2>
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="space-y-4 pt-4">
        <FreedomPrimeCard
          v-if="isFreedomPrimeOfferEnabled"
          source="all_special_offers"
        />
        <SpecialOfferCard
          v-for="item in specials"
          :id="item.id"
          :key="item.id"
          :title="item.title"
          :description="item.subtitle"
          :img="item.image_url"
          :price="item.price"
          :tags="item.tags"
          :banner-type="
            item.type === 'EVENT' ? BannerType.EVENTS : BannerType.FLIGHTS
          "
          source="all_special_offers"
        />
      </div>
    </template>
  </FreePageLayout>
</template>
<script setup lang="ts">
  import { watch } from 'vue';
  import {
    FreeBackButton,
    FreeHeader,
    FreePageLayout,
    amplitudeExperiment,
  } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';

  import { FreedomPrimeCard, SpecialOfferCard } from '@/widgets/special-offer';

  import { specialOffersModel } from '@/features/special-offers';

  import { BannerType, useSpecialOffers } from '@/entities/special-offers';

  import { analyticsEventsLib } from '@/shared/lib';

  const { t } = useI18n();

  const router = useRouter();
  const specialOffersStore = specialOffersModel.useSpecialOffersStore();
  const depCityCode = specialOffersStore.origCity.code;
  const { specials } = useSpecialOffers({ depCityCode });

  const { isVariant: isFreedomPrimeOfferEnabled } =
    amplitudeExperiment.lib.checkExperimentVariant(
      amplitudeExperiment.config.flags.SPECIAL_OFFER_FRIENDS,
      'offer_on',
    );

  watch(
    isFreedomPrimeOfferEnabled,
    isEnabled => {
      if (isEnabled) {
        analyticsEventsLib.specialOfferFriendsShown({
          source: 'all_special_offers',
        });
      }
    },
    { immediate: true },
  );
</script>
